export const CaseStatuses = {
  Stale: { value: 'Stale', displayValue: 'Stale' },
  OverdueReminders: { value: 'OverdueReminders', displayValue: 'Overdue' },
  RemindersAssigned: { value: 'RemindersAssigned', displayValue: 'Reminders assigned to me' },
};
